// extracted by mini-css-extract-plugin
export default {"main":"minorProjects_main__95usa","Heading":"minorProjects_Heading__KFeDf","Carousal":"minorProjects_Carousal__P4hY-"};